import { authenticateViaCognito, buildAuthUserFromCognitoSession } from '../../lib/auth/cognito';
import { authenticateViaApikey, authenticateViaLambda } from '../../lib/auth/restApi';
import { saveCognitoConnection, saveApiConnection, saveLambdaConnection, saveTempOktaConnection, saveTempOidcConnection } from '../utils/authStorage';
import { authActions } from '../slices/auth';

export const connectToCognito = connectionDetails => dispatch => {
  dispatch(authActions.CONNECTING());

  authenticateViaCognito(connectionDetails)
    .then(session => buildAuthUserFromCognitoSession(session))
    .then(user => {
      const cognitoConnection = saveCognitoConnection(connectionDetails);
      dispatch(authActions.CONNECTED_TO_COGNITO({ user, cognitoConnection }));
    })
    .catch(error => {
      dispatch(authActions.CONNECT_ERROR(error));
    });
};

export const connectViaApiKey = connectionDetails => dispatch => {
  dispatch(authActions.CONNECTING());

  authenticateViaApikey(connectionDetails)
    .then(response => {
      if (response.data?.__schema) {
        const apiConnection = saveApiConnection(connectionDetails);
        dispatch(authActions.CONNECTED_VIA_APIKEY({ apiConnection }));
      } else {
        throw new Error('Something went wrong, please try again.');
      }
    })
    .catch(error => {
      dispatch(authActions.CONNECT_ERROR(error));
    });
};

export const connectViaLambda = connectionDetails => dispatch => {
  dispatch(authActions.CONNECTING());

  authenticateViaLambda(connectionDetails)
    .then(response => {
      if (response.data?.__schema) {
        const lambdaConnection = saveLambdaConnection(connectionDetails);
        dispatch(authActions.CONNECTED_VIA_LAMBDA({ lambdaConnection }));
      } else {
        throw new Error('Something went wrong, please try again.');
      }
    })
    .catch(error => {
      dispatch(authActions.CONNECT_ERROR(error));
    });
};

export const connectViaOkta = connectionDetails => dispatch => {
  dispatch(authActions.CONNECTING());

  const oktaTempConnection = saveTempOktaConnection(connectionDetails);
  const url = `${oktaTempConnection.oktaServer}/oauth2/authorize?identity_provider=Okta&redirect_uri=${document.location.protocol}//${document.location.host}/sso/okta&response_type=token&client_id=${oktaTempConnection.userpoolClientId}`;

  document.location.href = url;
};

export const connectViaOIDC = connectionDetails => dispatch => {
  dispatch(authActions.CONNECTING());

  const oidcNonce = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  const oidcState = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  const oidcTempConnection = saveTempOidcConnection({ ...connectionDetails, oidcNonce, oidcState });

  const url = `${oidcTempConnection.oidcIssuer}/oauth2/v1/authorize?client_id=${oidcTempConnection.oidcClientId}&nonce=${oidcNonce}&state=${oidcState}&response_type=id_token&scope=openid%20profile%20email&redirect_uri=${document.location.protocol}//${document.location.host}/sso/oidc`;

  document.location.href = url;
};
